
import { useStore } from '@/store'
import { defineComponent, inject } from 'vue'
import { computed } from 'vue'
import nameSettings from '@/settings/name-settings.json'
import { ConfigurationActionTypes } from '@/store/modules/configuration/action-types'
import NameConverterService from '@/services/form/name-converter.service'
import Analytics from '@/singletons/analytics'
import FormOption from '@/components/Form/FormOption.vue'
import FormTab from '@/components/Abstract/FormTab.vue'

export default defineComponent({
  name: 'FormNameMobile',
  components: {
    FormTab,
    FormOption
  },
  props: {
    index: Number
  },
  setup() {
    const store = useStore()
    const emitter: any = inject('emitter')
    const configNonameId = computed(() => store.getters.configNonameId)
    const configNamechar = computed(() => store.getters.configNamechar)
    const configNamethreadId = computed(() => store.getters.configNamethreadId)
    const options = computed(() => nameSettings.nameitoColors)
    let nameConverterService = new NameConverterService()

    const onNoClick = () => {
      store.dispatch(ConfigurationActionTypes.SET_CONFIG_NONAME, nameSettings.noName.id)
      store.dispatch(ConfigurationActionTypes.SET_CONFIG_NAEMTHREAD, null)
      store.dispatch(ConfigurationActionTypes.SET_CONFIG_NAMECHAR, null)
      Analytics.instance.sendNameYesNo(false)
    }

    const onYesClick = () => {
      store.dispatch(ConfigurationActionTypes.SET_CONFIG_NONAME, nameSettings.yesName.id)
      emitter.emit('openMobileNameDialog')
    }

    const openMobileNameDialog = () => {
      emitter.emit('openMobileNameDialog')
    }

    const convertName = (name: string) => {
      return nameConverterService.convertToHTMLCharacters(name)
    }

    return {
      configNonameId,
      configNamechar,
      configNamethreadId,
      nameSettings,
      options,
      onNoClick,
      onYesClick,
      openMobileNameDialog,
      convertName
    }
  }
})
